module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['row', _vm.name],
    staticStyle: {
      "height": "45px",
      "padding-left": "15px"
    }
  }, [_c('div', {
    class: ['col-2', 'corner-rl', 'd-flex', 'align-items-center', (!_vm.label ? 'justify-content-around' : ''), (_vm.label ? 'labelRow' : 'icon')]
  }, [(_vm.label) ? _c('small', [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _vm._v(" "), (!_vm.label) ? _c('base-icon', {
    attrs: {
      "name": (_vm.icon ? _vm.icon : _vm.name)
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-5"
  }, [_c('div', {
    staticClass: "totalCount corner-rl d-flex align-items-center justify-content-around",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('span', {
    staticClass: "count",
    staticStyle: {
      "flex-grow": "1"
    }
  }, [_vm._v(_vm._s(_vm.data.count))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "flex-grow": "2"
    }
  }, [_c('small', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.data.total))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-5"
  }, [_c('div', {
    staticClass: "totalCount corner-rl d-flex align-items-center justify-content-around",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('span', {
    staticClass: "count",
    staticStyle: {
      "flex-grow": "1"
    }
  }, [_vm._v(_vm._s(_vm.data.monthlyCount))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "flex-grow": "2"
    }
  }, [_c('small', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.data.monthlyAvg))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d4597e1a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/dashboard/ShippingCostRow.vue
// module id = 774
// module chunks = 0